import { z } from 'zod';

import { createApiClient } from '../../api';
import { sidebarSchema } from '../sidebar/sidebarItems';
import type { SidebarItem } from '../sidebar/sidebarItems';

import { ACCESS_ENDPOINTS } from './endpoints';
import { errorFrom } from './http';
import { AccessContractError } from './schemas';

const { request } = createApiClient({ toError: errorFrom });

const resolvedMenuSchema = z.object({ menu: sidebarSchema });

export const fetchSidebar = async (signal?: AbortSignal): Promise<readonly SidebarItem[]> => {
  const raw = await request('get', ACCESS_ENDPOINTS.SIDEBAR, { params: { resolve: true }, signal });
  const parsed = resolvedMenuSchema.safeParse(raw);
  if (!parsed.success) throw new AccessContractError('Invalid /v2/permissions/menu payload', parsed.error.issues);
  return parsed.data.menu;
};
